// WP2-specific identity is centralized here so shared UI components can receive configuration.
const GAME_CONFIG = Object.freeze({
  key: 'wordpro',
  name: 'WordPro',
  wordmarkMain: 'Word',
  wordmarkAccent: 'Pro',
  badge: 'W',
  accent: '#4CAF50',
  timezone: process.env.REACT_APP_TIMEZONE || 'America/Phoenix',
});

export default GAME_CONFIG;
